import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from '../../../services/auth.service';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeInUpBigOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {UserService} from '../../../services/user.service';
import {Subscription} from 'rxjs';
import {EventsService} from '../../../services/events.service';
import {environment} from '../../../../environments/environment';
import {AnalyticsService} from '../../../services/analytics.service';
import {ReviewService} from '../services/review.service';
import {ReviewReportSimpleModel} from '../models/review.model';
import {LoadingController} from '@ionic/angular';

@Component({
    selector: 'app-review-page',
    templateUrl: 'review.page.html',
    styleUrls: ['review.page.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
        fadeInUpBigOnEnterAnimation({anchor: 'enterUp', duration: 300}),
    ],
})
export class ReviewPage implements OnInit, OnDestroy {
    subscriptions: Subscription[] = [];

    environment = null;
    menuVisible = true;

    reports: ReviewReportSimpleModel[] = null;
    reportsPromise: Promise<ReviewReportSimpleModel[]> = null;
    reportsValid = false;

    canAddReviewReport = false;
    canAddOne2OneReport = false;

    userType = null;

    platform = 'website';

    constructor(
        private event: EventsService,
        public authService: AuthService,
        public userService: UserService,
        private analytics: AnalyticsService,
        private reviewService: ReviewService,
        private loadingCtrl: LoadingController
    ) {
        this.environment = environment;
        this.subscriptions.push(
            this.event.subscribe('login', () => this.reportsValid = false)
        );
        this.subscriptions.push(
            this.event.subscribe('review.updateMyReviewReportStatus', () => this.reportsValid = false)
        );
        this.subscriptions.push(
            this.event.subscribe('review.saveMyReviewReport', () => this.reportsValid = false)
        );
        this.subscriptions.push(
            this.event.subscribe('review.deleteMyReviewReport', () => this.reportsValid = false)
        );
        this.subscriptions.push(
            this.event.subscribe('logout', () => this.reportsValid = false)
        );
    }

    ngOnInit(): void {
        this.platform = environment.platform;
    }

    ionViewWillEnter() {
        this.userType = this.authService.getUserType();

        if (this.reports === null || !this.reportsValid) {
            this.reportsPromise = this.reviewService.getMyReviewReportList()
        }
    }

    ionViewDidEnter() {
        this.analytics.trackView('Personal Development Review');

        if (this.reports === null || !this.reportsValid) {
            this.reportsPromise.then(data => {
                this.reports = data;
                this.reportsValid = true;
                this.setPermissions();
            });
        }
    }

    setPermissions() {
        this.canAddReviewReport = this.reports
            .filter(i => i.type === 'review')
            .reduce((acc, i) => !i.status ? false : acc, true);

        this.canAddOne2OneReport = this.reports
            .filter(i => i.type === 'one2one')
            .reduce((acc, i) => !i.status ? false : acc, true);
    }

    changeStatus(event, report: ReviewReportSimpleModel) {
        event.stopPropagation();
        report.status = !report.status;
        this.showLoading();
        this.reviewService.updateMyReviewReportStatus(report.id, report.status)
            .then(() => {
                this.reviewService.getMyReviewReportList().then(data => {
                    this.reports = data;
                    this.reportsValid = true;
                    this.setPermissions();
                });
            });
    }

    printReport(event, report: ReviewReportSimpleModel) {
        event.stopPropagation();

        let popupWin;
        if (report.type === 'one2one') {
            popupWin = window.open(window.location.href + '/my/report/one2one/' + report.id + '/print', '_blank');
        } else {
            popupWin = window.open(window.location.href + '/my/report/' + report.id + '/print', '_blank');
        }
        if (popupWin) {
            popupWin.onload = function() {
                setTimeout(() => {
                    popupWin.print();
                    popupWin.close();
                }, 5000); // Adjust timeout as needed for content to load
            }
        }
    }

    async showLoading() {
        const loading = await this.loadingCtrl.create({
            message: 'Loading...',
            duration: 1000,
            spinner: 'circles',
        });

        loading.present();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(i => i.unsubscribe());
    }
}
